<template>
    <div
      class="dst-container"
      :style="{ 
        width: (dwidth != undefined ? dwidth : 0) + 'px',
        height: (dheight != undefined ? dheight : 0) + 'px',
        left:  left + 'px', 
        top:  top + 'px',
        position: 'absolute',
        transform: arc? 'rotate(' + arc +'deg)' : 'rotate('+ 0 + 'deg)' }"
    >
      <template v-for="(layColor, index) in layersColors" :key="index">
        <div v-if="layColor!=-1"
         class="dst-layer"
        :style="{
          width: (dwidth != undefined ? dwidth : 0) + 'px',
          height: (dheight != undefined ? dheight : 0) + 'px',
          backgroundImage: getImagePath(index),
             backgroundPositionY: 'center',
          filter: `url(#ColorFilter-${layColor})`,
          opacity: transparent ? 30 + '%' : 100 + '%'
        }" >
      </div>
      <template v-else>
        <div v-for="(color, i) in colors"
        :key="i"
        class="dst-layerColorfull"
        :style="{
          width: (dwidth != undefined ? dwidth : 0) + 'px',
          height: (dheight != undefined ? dheight / 5 : 0) + 'px',
          backgroundImage: getImagePath(index),
          backgroundSize: `${dwidth}px ${dheight}px`, // הגדרת גודל הרקע
          backgroundPositionY: `-${(i * (dheight / 5))}px`, // הגדרת גובה
          filter: `url(#ColorFilter-${color})`, // תיקנתי את משתנה 'layColor' ל'color'
          opacity: transparent ? 30 + '%' : 100 + '%',
          top: `${i * (dheight / 5)}px`, // הוספת top לשכבות
          position: 'absolute',
          // backgroundRepeat: 'no-repeat'
        }"></div>
    </template>
      </template>   
  </div>
</template>
  
  <script>
  import { designerStore } from "@/stores/designerStore";
  
  export default {
    data() {
      return {
        isColorfull:false, 
      };
    },
    setup() {
      const store = designerStore();  
      const colors=[40,36,37,38,39]
      return {
        store,
        colors
      };
    },
    props: ["dstFile", "layersColors", "dwidth", "dheight", "left", "top", "transparent", "arc"],
    methods: {
      getImagePath(index){
        // const url = `${this.dstFile.relativePath.replaceAll('\\', '\\\\')}_${index+1}`;
        // var encodingUrl = encodeURIComponent(url);
        // return `url('${this.store.baseURL}\\\\${this.dstFile.relativePath.replaceAll('\\', '\\\\')}_${index+1}.PNG')`;
        return `url('http://embapi.ideali.club\\\\${this.dstFile.relativePath.replaceAll('\\', '\\\\')}_${index+1}.PNG')`;
        // return `url('${this.store.baseURL}\\\\${this.dstFile.relativePath.replaceAll('\\', '\\\\')}_${index+1}.PNG')`;
      }
    }
  };
  </script>
  
  <style>

.dst-container {
  text-align: start;
  }  
.dst-layer {
    position: absolute; 
    top: 0;
    background-size: contain;
    background-repeat: no-repeat;
  }
  
  </style>
  